export default {
  settings: 'Instellingen',
  storefront: 'Storefront',
  media: 'Media',
  style: 'Stijl',
  scripts: 'Scripts',
  no_google_place: {
    title: 'Het bedrijf is niet gekoppeld aan een Google-locatie',
    description: 'Koppel het bedrijf aan een Google-locatie',
  },
};
